import { ApiCall } from './CustomHooks';
import { GetSession } from 'session-manager-beta';

const virtualPath = '';
const autoCompleteDelay = 300;
export { autoCompleteDelay, virtualPath };


var user = GetSession('cookies', 'user');

const config = {
    token: process.env.REACT_APP_SECRET_KEY,
    LoginToken: user?.loginSessionID ? user?.loginSessionID : null,
    UserCode: user?.userCode ? user?.userCode : null,
    EName: user?.userName ? user?.userName : null,
    companyCode: user?.companyCode ? user?.companyCode : null,
    loginUserType: user?.loginUserType ? user?.loginUserType : null
}


export default config

export const CommonApiData = () => {
    const token = process.env.REACT_APP_SECRET_KEY;
    var user = GetSession('cookies', 'user');
    if (user) {
        let data = {
            AuthToken: token,
            LoginToken: user.loginSessionID ? user.loginSessionID : '',
            UserCode: user.userCode ? user.userCode : '',
            UserName: user.userName ? user.userName : '',
            loginUserType: user.loginUserType ? user.loginUserType : ''
        }
        return data
    } else {
        return {
            AuthToken: token,
            LoginToken: 'EXPIRED',
            UserCode: '',
            UserName: '',
            CompanyCode: '',
            loginUserType: ''
        };
    }
}

let baseUrl;
if (window.location.hostname.indexOf("react.") >= 0) {
    baseUrl = `${window.location.protocol}//${window.location.host}/${window.location.pathname.split('/')[1]}`;
} else {
    baseUrl = `${window.location.protocol}//${window.location.host}`;
}
export const API_SERVER = baseUrl;

export const initializeFilterData = {
    "SearchText": "",
    "StartValue": "2",
    "SearchFieldValue": "",
    "PageSize": "10",
    "AdvanceFilter": []
}

//-------------Data Copy to clipboard------------//
export const copyToClipboard = (text) => {
    var textField = document.createElement('textarea')
    textField.innerText = text
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()
};

//------------------Get Financial Year Data-----------------//
export const getCurrentFinancialYear = () => {
    const launchYear = 2023; // Default Lauch Year
    const today = new Date(); // current Date
    const month = today.getMonth(); //current Month
    const currentYear = today.getFullYear(); // Current Year
    let financialYearArr = [];
    for (let i = 0; i <= (currentYear - launchYear); i++) {
        if ((month + 1) <= 3) {
            financialYearArr.push({
                value: `${(currentYear - i - 1)}-${(currentYear - i)}`,
                label: `${(currentYear - i - 1)}-${(currentYear - i).toString().slice(-2)}`,
            })
        } else {
            financialYearArr.push({
                value: `${(currentYear - i)}-${(currentYear - i + 1)}`,
                label: `${(currentYear - i)}-${(currentYear - i + 1).toString().slice(-2)}`
            })
        }
    }
    return { financialYearArr, currentYear: (month + 1) <= 3 ? (currentYear - 1) + "-" + currentYear : currentYear + "-" + (currentYear + 1) }
}

//--------------------Convent base 64 To Blob-------------------------//
export const base64ToBlob = (base64, type = "application/octet-stream") => {
    const binStr = atob(base64);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type: type });
}

//---------------Convert JSON into Array -----------------//
export const JSONToArray = (data, columns) => {

    //--- Convert object keys to an array ---//
    const keysArray = Object.keys(data);

    //--- Extract key-value pairs ---//
    const keyValuePairs = keysArray.map(key => [key, data[key]]);

    //--- division the array into pairs of key-value pairs and no. of column in a row ---//
    const keyValuePairsData = [];
    for (let i = 0; i < keyValuePairs.length; i += columns) {
        keyValuePairsData.push(keyValuePairs.slice(i, i + columns));
    }

    return keyValuePairsData
}

export const capitalizeFirstLetter = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
}

//---------------Convert Array to  no. of columns in table -----------------//
export const ArrayToRows = (data, columns) => {

    //--- division the array into pairs of key-value pairs and no. of column in a row ---//
    const keyValuePairsData = [];
    for (let i = 0; i < data.length; i += columns) {
        keyValuePairsData.push(data.slice(i, i + columns));
    }

    return keyValuePairsData
}

export const CheckAvailability = () => {
    return <svg
        width="16px"
        height="16px"
        viewBox="0 0 133 133"
        xmlns=" http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g
            id="check-group"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <circle id="filled-circle" fill="#008000" cx={66.5} cy={66.5} r={54.5} />
            <circle id="white-circle" fill="#FFFFFF" cx={66.5} cy={66.5} r={55.5} />
            <circle
                id="outline"
                stroke="#008000"
                strokeWidth={4}
                cx={66.5}
                cy={66.5}
                r={54.5}
            />
            <polyline
                id="check"
                stroke="#FFFFFF"
                strokeWidth={16}
                points="41 70 56 85 92 49"
            />
        </g>
    </svg>
}

//------  Show File ------------//
export const handleShowFile = async (payload) => {
    try {
        let imgresult = await ApiCall('/api/Image/GetImage', { ...payload });
        let result = imgresult.data;
        if (result.fileType === 'pdf') {
            const blob = base64ToBlob(result?.fileBase64?.split(',')[1], 'application/pdf');
            const url = URL.createObjectURL(blob);
            const pdfWindow = window.open(url, '_blank');
            if (!pdfWindow) {
                throw new Error("Please allow pop-ups for this site");
            }
            pdfWindow.document.title = "View PDF";
        }
        else if (result.fileType === 'down') {
            const link = document.createElement('a');
            link.href = `data:image/jpeg;base64,${result.fileBase64}`;
            link.download = 'image.jpg';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        else {
            const blob = base64ToBlob(result?.fileBase64?.split(',')[1], 'image/jpeg');
            const url = URL.createObjectURL(blob);
            const imageWindow = window.open(url, '_blank');
            if (!imageWindow) {
                throw new Error("Please allow pop-ups for this site");
            }
            imageWindow.document.title = "View Image";
        }
    } catch (error) {
        console.error('Error handling file:', error);
    }
}

//----- Download file -----//
export const handleDownload = async (payload) => {
    try {
        let imgResult = await ApiCall('/api/Image/GetImage', { ...payload });

        if (imgResult?.data?.fileBase64) {
            const base64String = imgResult.data.fileBase64.split(',')[1].trim();
            const contentType = imgResult?.data?.contentType || 'application/octet-stream';
            const dataURI = `data:${contentType};base64,${base64String}`;
            const link = document.createElement("a");
            link.href = dataURI;
            link.download = imgResult?.data?.fileType.toUpperCase() === 'PDF' ? "file.pdf" : 'image.jpg';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            console.error("Base64 string is empty or undefined.");
        }
    } catch (error) {
        console.error("Error while handling download:", error);
    }
};

//---------- get File Name and Extension --------------//
export const getFileNameAndExtension = (fileName) => {
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1) {
        console.log("No extension found");
    } else {
        const name = fileName.substring(0, lastDotIndex); // capture the Name of Uploaded file
        const extension = fileName.substring(lastDotIndex + 1); // capture the Extension of Uploaded file
        return { name, extension }
    }
}